import dayjs from '@/utils/dayjs.config';
import { DateFilterInputValue, DateRange } from '../types';
import { formatDateToDateInputValue } from '@/utils/formatDateToDateInputValue';

const getRangeFromToday = (days: number): DateRange => {
  const now = dayjs();
  const startDate = formatDateToDateInputValue(now.startOf('day').subtract(days, 'days').toDate());
  const endDate = formatDateToDateInputValue(now.endOf('day').toDate());

  return { startDate, endDate };
};

export const mapDateValueToDateRange = (dateValue: DateFilterInputValue): DateRange => {
  switch (dateValue) {
    case DateFilterInputValue.SEVEN:
      return getRangeFromToday(7);
    case DateFilterInputValue.FIFTEEN:
      return getRangeFromToday(15);
    case DateFilterInputValue.THIRTY:
      return getRangeFromToday(30);
    case DateFilterInputValue.NINETY:
      return getRangeFromToday(90);
    case DateFilterInputValue.DEFINE_DATE:
      return { startDate: '', endDate: '' };
    case DateFilterInputValue.ALL:
      return { startDate: '', endDate: '' };
    default:
      return { startDate: '', endDate: '' };
  }
};
